import { FunctionComponent } from 'react';
import './ModalWrapComp.scss';

export interface IModalWrapComp {
  label?: string;
  children: any;
  closeModal: () => void;
  classes?: string;
  justifyContent?:string;
  alignItems?:string;
  contentInModalClass?:any;
  paddingRight?:string;
  paddingLeft?:string;
}

const ModalWrapComp: FunctionComponent<IModalWrapComp> = ({
  children,
  closeModal,
  classes,
  justifyContent,
  alignItems,
  contentInModalClass,
  paddingLeft,
  paddingRight,
}) => (
  <div className={`app-modal modalwrapcomp ${classes || ''}`} style={{ justifyContent, alignItems }}>
    <div onClick={() => closeModal()} className="dark-env" />
    <div className={contentInModalClass || 'content-in-modal p-0 m-0'}>
      <div className="container" style={{ paddingLeft, paddingRight }}>
        {children}
      </div>
    </div>
  </div>
);

export default ModalWrapComp;
